import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/progress.png'
import _imports_1 from '@/assets/notice-bj.png'


const _withScopeId = n => (_pushScopeId("data-v-4fc218ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-bg" }, null, -1))
const _hoisted_3 = { class: "home-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/home/banner.png",
    alt: ""
  })
], -1))
const _hoisted_5 = { class: "task-content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "核保体检服务", -1))
const _hoisted_7 = {
  key: 0,
  class: "progress-icon",
  src: _imports_0,
  alt: ""
}
const _hoisted_8 = { class: "left hea-flex-item1 hea-column" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"bt hea-row\" data-v-4fc218ce><div class=\"name\" data-v-4fc218ce>视频问卷 </div><div class=\"hea-row time hea-justifyC\" data-v-4fc218ce> ( <span class=\"hea-justifyC\" data-v-4fc218ce><img src=\"/images/home/time-ico.png\" alt=\"\" class=\"time-ico\" data-v-4fc218ce> 9:00-21:00 </span> ) </div></div>", 1)
const _hoisted_10 = { class: "number" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 您有")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("份问卷 ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 暂无问卷 ")
const _hoisted_14 = {
  key: 0,
  class: "busy"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/home/doctor.png",
  alt: ""
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "当前医生繁忙可能需等候", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  class: "right"
}
const _hoisted_19 = { class: "select hea-justifyCR" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("立即查看")
const _hoisted_21 = {
  key: 0,
  class: "progress-icon",
  src: _imports_0,
  alt: ""
}
const _hoisted_22 = { class: "left hea-flex-item1 hea-column" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bt hea-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "name" }, "体检预约")
], -1))
const _hoisted_24 = { class: "number" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 您有")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("份体检 ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 暂无体检 ")
const _hoisted_28 = {
  key: 1,
  class: "right"
}
const _hoisted_29 = { class: "select hea-justifyCR" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("立即查看")
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "体检报告", -1))
const _hoisted_33 = { class: "task-list report-bg" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "报告查询", -1))
const _hoisted_35 = { class: "number" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" 您有")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("份体检报告 ")
const _hoisted_38 = { class: "select" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode("立即查看")
const _hoisted_40 = {
  key: 1,
  class: "number"
}
const _hoisted_41 = { class: "pop-nr" }
const _hoisted_42 = { class: "hea-row pop-header" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title hea-flex-item1 hea-justifyB" }, "请选择体检人", -1))
const _hoisted_44 = { class: "hea-row pop-item hea-justifyC" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_46 = { class: "notice-wrap" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "notice-title" }, "尊敬的先生/女士:", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "为了保证服务质量，维护您的权利，本次问卷将被全程录像，并成为友邦人寿为您办理保险合同相关业务的依据。", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 为实现视频问卷功能，友邦人寿需要收集本人的人脸识别信息和录音录像信息。人脸识别及录音录像信息属于敏感个人信息，即一旦泄露或者非法使用容易对个人权益造成影响的个人信息。如不提供前述敏感个人信息，友邦将无法实现所述目的。 ", -1))
const _hoisted_50 = /*#__PURE__*/_createTextVNode("本人已知晓并同意")
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "overlay-wrapper-img",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hea-justifyC" }, "视频问卷服务工作时间为：9:00-21:00，请届时进行视频问卷服务。谢谢！", -1))
const _hoisted_53 = { class: "btn-list overlay-btn" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "overlay-wrapper-img",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hea-justifyC" }, "上次视频问卷中断，请您确认", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hea-justifyC" }, "是否继续", -1))
const _hoisted_57 = { class: "btn-list overlay-btn" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "overlay-wrapper-img",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hea-justifyC" }, "上次视频问卷未完成签名，请您", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hea-justifyC" }, "确认是否补签", -1))
const _hoisted_61 = {
  class: "btn-list overlay-btn",
  style: {"padding":"0 16px"}
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "overlay-wrapper-img",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hea-justifyC" }, "当前来电高峰期，预计等待时间较长。", -1))
const _hoisted_64 = { class: "btn-list overlay-btn" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "overlay-wrapper-img",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_66 = { class: "hea-justifyC" }
const _hoisted_67 = { class: "btn-list overlay-btn" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "overlay-wrapper-img",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hea-justifyC" }, "请使用微信(6.5以上版本)点击链接或微信扫码进入视频问卷。", -1))
const _hoisted_70 = { class: "btn-list overlay-btn" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "overlay-wrapper-img",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hea-justifyC" }, "当前您的手机型号或版本不支持视频问卷，建议您更换手机尝试，感谢您的支持与配合。", -1))
const _hoisted_73 = { class: "btn-list overlay-btn" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "overlay-wrapper-img",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hea-justifyC" }, "本次问卷大约需要15分钟,是否继续问卷。", -1))
const _hoisted_76 = { class: "btn-list overlay-btn" }

import {
  computed,
  defineComponent,
  onUnmounted,
  getCurrentInstance,
  nextTick,
  onMounted,
  reactive,
  toRefs,
  ref,
} from "vue";
import tabbar from "src/components/common/tabbar";
import { Toast } from "vant";
import JSEncryptUtils from "utils/encrypt-utils";
import dayjs from "dayjs";
import config from "src/config";
import { useTRTCStore, useUserInfo } from "src/store";
import { MemberService, TRTCService, GaodeService, PhysicalService } from "src/services";
import { useToken } from "src/store";
import { useRouter, useRoute } from "vue-router";
import patterns from "src/utils/patterns";
import TRTC from "trtc-js-sdk";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { setAccessToken, setRefreshToken } = useToken();
const { getUserInfo } = useUserInfo();
const router = useRouter();
const route = useRoute();
// 人员数组
let memberData = ref<Array<any>>([]);
let state = reactive({
  awaitModal: false,
  vacation: {
    showModal: false,
    msg: "",
  },
  timer: null,
  isBusy: false,
  isShowNotice: false, // 当前医生是否繁忙
  showPermission: false,
  showDiscontinue: false, // 异常中断
  showSign: false, // 未签名
  // 当前人员信息
  checkMember: {
    canPassFaceVerify: false,
    cardType: 1,
    hasProgressTask: false,
    id: null,
    isMainAccount: false,
    name: "",
    progressTaskId: null,
    progressTaskStatus: null,
    sex: null,
  },
});

let show = ref<boolean>(false);
let showNotice = ref<boolean>(false);
let showWorking = ref<boolean>(false);
let showType = ref<number>(1);
// 浏览器弹框
let showBrowserModal = ref<boolean>(false);
// 手机型号弹框
let showPhoneModal = ref<boolean>(false);

onMounted(async () => {
  getTaskInfo();
  getGeolocation();
  isBusy();
  state.timer = setInterval(() => {
    isBusy();
  }, 1000 * 10);
});

onUnmounted(() => {
  if (state.timer) {
    clearInterval(state.timer);
    state.timer = null;
  }
});

/* 获取当前位置信息
 * @private
 * @returns void
 */
const getGeolocation = async () => {
  let data = await GaodeService.instance.getBaiduLocation();
  localStorage.setItem("location", JSON.stringify(data));
};

let taskNum = reactive({
  questionnaireTaskCount: 0, // 问卷任务数量
  physicalTaskCount: 0, // 体检任务数量
  reportCount: 0, // 未读报告数量
});

// 当前登入用户信息
let userInfo = computed(() => {
  return getUserInfo();
});

// 获取任务数据
const getTaskInfo = async (): Promise<void> => {
  try {
    let { content: reslut } = await MemberService.instance.getTaskInfo();
    if (reslut.data) {
      taskNum.questionnaireTaskCount = reslut.data.questionnaireTaskCount || 0;
      taskNum.physicalTaskCount = reslut.data.physicalTaskCount || 0;
      taskNum.reportCount = reslut.data.reportCount || 0;
    }
  } catch (err) {
    Toast(err);
  }
};

// 异常中断
const continueQuestionnaire = () => {
  // 未进行
  router.push({ name: "calling", query: { id: state.checkMember.progressTaskId + "" } });
};

// 继续等待
const onAwait = () => {
  if (!state.checkMember.canPassFaceVerify) {
    // 身份证调人脸
    router.push({ name: "face-verify", query: { id: state.checkMember.progressTaskId + "" } });
  } else {
    router.push({ name: "calling", query: { id: state.checkMember.progressTaskId + "" } });
  }
};

// 补签
const countersign = () => {
  state.showSign = false;
  if (state.checkMember.canPassFaceVerify) {
    // 非身份证
    router.push({ name: "countersign", query: { id: state.checkMember.progressTaskId + "" } });
  } else {
    // 身份证
    router.push({ name: "face-verify", query: { id: state.checkMember.progressTaskId + "", type: "2" } });
  }
};

// 页面跳转
const onPage = (name: string) => {
  router.push({ name: name });
};

let isWork = computed(() => {
  // 不在工作时间
  if (config.questionnaireConfig.enable) {
    let HH = +dayjs().format("HH");
    if (HH >= (config.questionnaireConfig.startDate || 9) && HH < (config.questionnaireConfig.endDate || 21)) {
      return true;
    }

    return false;
  }

  return true;
});

// 问卷前判断
async function onSelectQuestionnaire() {
  // 判断是否有问卷
  if (taskNum.questionnaireTaskCount == 0) {
    return;
  }
  onQuestionnaire();
}

// 问卷
async function onQuestionnaire() {
  showType.value = 1;

  try {
    let { content: reslut } = await MemberService.instance.getMembers(1);

    if (reslut.data) {
      memberData.value = reslut.data.filter((item) => item.hasProgressTask);

      if (memberData.value.length == 1) {
        state.checkMember = memberData.value[0];
        handlerQuestionnaireState();
      } else if (memberData.value.length > 1) {
        state.checkMember = memberData.value[0];
        show.value = true;
      }
    }
  } catch (err) {
    Toast(err);
  }
}

async function isBusy() {
  if (!isWork.value) {
    if (state.timer) {
      clearInterval(state.timer);
    }
    return;
  }

  try {
    let { content: reslut } = await TRTCService.instance.isBusy();

    state.isBusy = reslut.data.isBusy;
  } catch (err) {
    console.log(err);
  }
}

async function checkState() {
  try {
    let { content: result } = await TRTCService.instance.checkState(userInfo.value.userId + "");
    return result.data.isShowNotice;
  } catch (err) {
    console.log(err);
  }
}
// 判断是否为节假日
async function validateVacation() {
  try {
    let { content: result } = await PhysicalService.instance.validateVacation();
    // 判断是否可以问卷(节假日)
    if (result.data.isVacationQues) {
      let ua = navigator.userAgent.toLowerCase();

      // 判断是否在工作时间内
      if (!isWork.value) {
        showWorking.value = true;
        return;
      }
      // 浏览器
      if (!(ua.indexOf("micromessenger") > -1)) {
        // 请使用微信(6.5以上版本)点击链接或微信扫码进入视频问卷
        showBrowserModal.value = true;
        return;
      }

      // 手机型号
      if (ua.indexOf("iphone") > -1) {
        var ver = ua.match(/cpu iphone os (.*?) like mac os/);
        let versionList = ver[1].split("_");
        let version = `${versionList[0]}${versionList[1]}`;
        if (+version < 143) {
          showPhoneModal.value = true;
          return;
        }
      }

      if (state.checkMember.progressTaskStatus == 1) {
        // 未进行
        if (await checkState()) {
          state.isShowNotice = true;
        } else {
          // 未进行
          // 15分钟提醒
          state.awaitModal = true;
          // showNotice.value = true;
        }
      } else if (state.checkMember.progressTaskStatus == 2) {
        // 异常中断
        state.showDiscontinue = true;
      }
    } else {
      state.vacation.showModal = true;
      state.vacation.msg = result.data.msg;
    }
  } catch (err) {
    console.log(err);
  }
}
// 15分钟继续问卷
function onContinueQuestionnaire() {
  state.awaitModal = false;
  showNotice.value = true;
}

async function onSelectPhysical() {
  if (taskNum.physicalTaskCount == 0) {
    return;
  }
  showType.value = 2;

  try {
    let { content: reslut } = await MemberService.instance.getMembers(2);

    if (reslut.data) {
      memberData.value = reslut.data.filter((item) => item.hasProgressTask);

      if (memberData.value.length == 1) {
        state.checkMember = memberData.value[0];
        router.push({ name: "detail", query: { id: state.checkMember.progressTaskId + "" } });
      } else if (memberData.value.length > 1) {
        state.checkMember = memberData.value[0];
        show.value = true;
      }
    }
  } catch (err) {
    Toast(err);
  }
}

const handlerQuestionnaireState = async () => {
  if (state.checkMember.progressTaskStatus == 3) {
    // 未签名
    state.showSign = true;
  } else {
    // 判断是否节假日及其它验证
    validateVacation();
  }
};

// 确认选择人员
const onPickBtn = (): void => {
  // 视频问卷前需要弹框验证
  if (showType.value == 1) {
    handlerQuestionnaireState();
  } else {
    // 体检任务
    router.push({ name: "detail", query: { id: state.checkMember.progressTaskId + "" } });
  }

  show.value = false;
};

// 确认
const onConfirmNotice = (): void => {
  // 视频问卷任务选择人员确认
  if (state.checkMember.progressTaskId && showType.value == 1) {
    if (!state.checkMember.canPassFaceVerify) {
      // 身份证调人脸
      router.push({ name: "face-verify", query: { id: state.checkMember.progressTaskId + "" } });
    } else {
      router.push({ name: "calling", query: { id: state.checkMember.progressTaskId + "" } });
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", {
          class: _normalizeClass(["task-list hea-row questionnaire-bg", 
            _unref(state).isBusy && _unref(taskNum).questionnaireTaskCount > 0 && _unref(isWork) ? 'questionnaire-bg1' : 'questionnaire-bg'
          ]),
          onClick: onSelectQuestionnaire
        }, [
          (_unref(taskNum).questionnaireTaskCount > 0)
            ? (_openBlock(), _createElementBlock("img", _hoisted_7))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              (_unref(taskNum).questionnaireTaskCount > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_11,
                    _createElementVNode("i", null, _toDisplayString(_unref(taskNum).questionnaireTaskCount), 1),
                    _hoisted_12
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_13
                  ], 64))
            ]),
            (_unref(state).isBusy && _unref(taskNum).questionnaireTaskCount > 0 && _unref(isWork))
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_17))
              : _createCommentVNode("", true)
          ]),
          (_unref(taskNum).questionnaireTaskCount > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode(_component_van_icon, { name: "arrow" })
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: "task-list hea-row physical-bg",
          onClick: onSelectPhysical
        }, [
          (_unref(taskNum).physicalTaskCount > 0)
            ? (_openBlock(), _createElementBlock("img", _hoisted_21))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              (_unref(taskNum).physicalTaskCount > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_25,
                    _createElementVNode("i", null, _toDisplayString(_unref(taskNum).physicalTaskCount), 1),
                    _hoisted_26
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_27
                  ], 64))
            ])
          ]),
          (_unref(taskNum).physicalTaskCount > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createVNode(_component_van_icon, { name: "arrow" })
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_31,
        _hoisted_32,
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", {
            class: "hea-column",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onPage('reportList')))
          }, [
            _hoisted_34,
            (_unref(taskNum).reportCount)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("i", null, _toDisplayString(_unref(taskNum).reportCount), 1),
                    _hoisted_37
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _createVNode(_component_van_icon, { name: "arrow" })
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_40, "暂无体检报告"))
          ])
        ])
      ])
    ]),
    (_unref(show))
      ? (_openBlock(), _createBlock(_component_van_popup, {
          key: 0,
          show: _unref(show),
          "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (_isRef(show) ? (show).value = $event : show = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_41, [
              _createVNode(_component_van_picker, {
                title: "请选择体检人",
                columns: _unref(memberData),
                swipeDuration: 10,
                onChange: _cache[2] || (_cache[2] = 
            (event) => {
              _unref(state).checkMember = event;
            }
          )
              }, {
                toolbar: _withCtx(() => [
                  _createElementVNode("div", _hoisted_42, [
                    _hoisted_43,
                    _createElementVNode("div", {
                      class: "close",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(show) //@ts-ignore
 ? show.value = false : show = false))
                    }, [
                      _createVNode(_component_van_icon, { name: "cross" })
                    ])
                  ])
                ]),
                option: _withCtx((item) => [
                  _createElementVNode("div", _hoisted_44, _toDisplayString(item.name), 1)
                ]),
                _: 1
              }, 8, ["columns"]),
              _createVNode(_component_van_button, {
                round: "",
                color: "linear-gradient(to right, #F8628A, #E23A67)",
                class: "pick-btn",
                onClick: onPickBtn
              }, {
                default: _withCtx(() => [
                  _hoisted_45
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["show"]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_popup, {
      show: _unref(showNotice),
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => (_isRef(showNotice) ? (showNotice).value = $event : showNotice = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_46, [
          _hoisted_47,
          _hoisted_48,
          _hoisted_49,
          _createVNode(_component_van_button, {
            round: "",
            color: "linear-gradient(to right, #F8628A, #E23A67)",
            class: "pick-btn notice-btn",
            onClick: onConfirmNotice
          }, {
            default: _withCtx(() => [
              _hoisted_50
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_overlay, {
      show: _unref(showWorking),
      class: "notice-overlay"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_51,
          _hoisted_52,
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_isRef(showWorking) //@ts-ignore
 ? showWorking.value = false : showWorking = false))
            }, "确定")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_overlay, {
      show: _unref(state).showDiscontinue,
      class: "notice-overlay",
      onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(state).showDiscontinue = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_54,
          _hoisted_55,
          _hoisted_56,
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("button", {
              class: "btn-cancel van-hairline--surround",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(state).showDiscontinue = false))
            }, "取消"),
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: continueQuestionnaire
            }, "继续问卷")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_overlay, {
      show: _unref(state).showSign,
      class: "notice-overlay",
      onClick: _cache[12] || (_cache[12] = ($event: any) => (_unref(state).showSign = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          style: {"padding-left":"0","padding-right":"0"},
          onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_58,
          _hoisted_59,
          _hoisted_60,
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("button", {
              class: "btn-cancel van-hairline--surround",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(state).showSign = false))
            }, "取消"),
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: countersign
            }, "补签")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_overlay, {
      show: _unref(state).isShowNotice,
      class: "notice-overlay",
      onClick: _cache[16] || (_cache[16] = ($event: any) => (_unref(state).isShowNotice = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          onClick: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_62,
          _hoisted_63,
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("button", {
              class: "btn-cancel van-hairline--surround",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_unref(state).isShowNotice = false))
            }, "挂断"),
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (onAwait()))
            }, "继续等待")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_overlay, {
      show: _unref(state).vacation.showModal,
      class: "notice-overlay",
      onClick: _cache[19] || (_cache[19] = ($event: any) => (_unref(state).vacation.showModal = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          onClick: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_65,
          _createElementVNode("p", _hoisted_66, _toDisplayString(_unref(state).vacation.msg), 1),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("button", {
              class: "btn-cancel van-hairline--surround",
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_unref(state).vacation.showModal = false))
            }, "确定")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_overlay, {
      show: _unref(showBrowserModal),
      class: "notice-overlay",
      onClick: _cache[22] || (_cache[22] = ($event: any) => (_isRef(showBrowserModal) //@ts-ignore
 ? showBrowserModal.value = false : showBrowserModal = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          onClick: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_68,
          _hoisted_69,
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("button", {
              class: "btn-cancel van-hairline--surround",
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_isRef(showBrowserModal) //@ts-ignore
 ? showBrowserModal.value = false : showBrowserModal = false))
            }, "确定")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_overlay, {
      show: _unref(showPhoneModal),
      class: "notice-overlay",
      onClick: _cache[25] || (_cache[25] = ($event: any) => (_isRef(showPhoneModal) //@ts-ignore
 ? showPhoneModal.value = false : showPhoneModal = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          onClick: _cache[24] || (_cache[24] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_71,
          _hoisted_72,
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("button", {
              class: "btn-cancel van-hairline--surround",
              onClick: _cache[23] || (_cache[23] = ($event: any) => (_isRef(showPhoneModal) //@ts-ignore
 ? showPhoneModal.value = false : showPhoneModal = false))
            }, "确定")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_overlay, {
      show: _unref(state).awaitModal,
      class: "notice-overlay",
      onClick: _cache[29] || (_cache[29] = ($event: any) => (_unref(state).awaitModal = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          onClick: _cache[28] || (_cache[28] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_74,
          _hoisted_75,
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("button", {
              class: "btn-cancel van-hairline--surround",
              onClick: _cache[26] || (_cache[26] = ($event: any) => (_unref(state).awaitModal = false))
            }, "下次再问"),
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: _cache[27] || (_cache[27] = ($event: any) => (onContinueQuestionnaire()))
            }, "继续问卷")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(tabbar))
  ]))
}
}

})